import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBlock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 82,
	height: 82,
	viewBox: "0 0 82 82",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M41 0.375C32.9652 0.375 25.1107 2.75761 18.43 7.22155C11.7492 11.6855 6.54222 18.0302 3.46741 25.4535C0.392602 32.8767 -0.411908 41.0451 1.15562 48.9255C2.72314 56.806 6.5923 64.0447 12.2738 69.7262C17.9553 75.4077 25.194 79.2769 33.0745 80.8444C40.955 82.4119 49.1233 81.6074 56.5465 78.5326C63.9698 75.4578 70.3145 70.2508 74.7785 63.57C79.2424 56.8893 81.625 49.0349 81.625 41C81.6136 30.2291 77.3299 19.9025 69.7137 12.2863C62.0975 4.67015 51.7709 0.386374 41 0.375ZM75.375 41C75.383 49.0372 72.5604 56.8206 67.4024 62.9844L19.0156 14.5938C24.0352 10.4179 30.1402 7.75798 36.6163 6.9253C43.0924 6.09263 49.6718 7.12163 55.5844 9.8919C61.497 12.6622 66.4984 17.0591 70.0032 22.5682C73.508 28.0772 75.3713 34.4706 75.375 41ZM6.62502 41C6.61702 32.9628 9.43966 25.1794 14.5977 19.0156L62.9844 67.4062C57.9649 71.5821 51.8598 74.242 45.3837 75.0747C38.9076 75.9074 32.3283 74.8784 26.4156 72.1081C20.503 69.3378 15.5017 64.9409 11.9968 59.4318C8.49204 53.9228 6.62875 47.5294 6.62502 41Z",
		fill: "current"
	})
});
export default SvgBlock;
